import { UseMutationResult } from '@tanstack/react-query';
import { ProximityReportParameters, ReportsApi } from 'oas';
import { useApiMutation } from '../use-api-mutation';

export const useGenerateProximityReport = (): UseMutationResult<void, unknown, ProximityReportParameters> => {
    return useApiMutation(async (attr, apiConfig, axiosInstance) => {
        await new ReportsApi(apiConfig, '', axiosInstance).generateProximityReport(attr);
    });
};
